import React, { Fragment } from "react";
import { DollarSign, Tag, ShoppingBag, Sun } from "react-feather";
import CountUp from "react-countup";
import ChartistGraph from "react-chartist";
// import { chart1, chartsmall } from "../../../charts-data/default";

const primary = localStorage.getItem("primary_color") || "#4466f2";
const secondary = localStorage.getItem("secondary_color") || "#1ea6ec";

const CollectionView = (infoProps) => {
  const { title, memberCollection, collectionDealer, totalMember } = infoProps;
  console.log({infoProps})
  return (
    <Fragment>
      <div className="col-xl-6 xl-50 col-md-6">
        <div className="card">
          <div className="card-header">
            <h5>{title}</h5>
          </div>
          <div className="card-body height-equal">
            {memberCollection &&
              memberCollection.map((collection, index) => {
                return (
                  <div key={"collection" + index} className="progress-block">
                    <div className="progress-title">
                      <span>{collection.name}</span>
                      <span className="pull-right">
                        {Math.round(
                          (collection.totalCount * 100) / totalMember
                        )}
                        %
                      </span>
                    </div>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className="progress-bar bg-danger"
                        role="progressbar"
                        style={{
                          width:
                            Math.round(
                              (collection.totalCount * 100) / totalMember
                            ) + "%"
                        }}
                        aria-valuenow={Math.round(
                          (collection.totalCount * 100) / totalMember
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                );
              })}
            {collectionDealer &&
              collectionDealer.map((collection, index) => {
                return (
                  <div key={"collection" + index} className="progress-block">
                    <div className="progress-title">
                      <span>{collection.name}</span>
                      <span className="pull-right">
                        {Math.round(
                          (collection.totalSubscribe * 100) / totalMember
                        )}
                        %
                      </span>
                    </div>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className="progress-bar bg-danger"
                        role="progressbar"
                        style={{
                          width:
                            Math.round(
                              (collection.totalSubscribe * 100) / totalMember
                            ) + "%"
                        }}
                        aria-valuenow={Math.round(
                          (collection.totalSubscribe * 100) / totalMember
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                );
              })}
            {/* <div className="progress-block">
              <div className="progress-title">
                <span>Portfolio</span>
                <span className="pull-right">5/6</span>
              </div>
              <div className="progress" style={{ height: "8px" }}>
                <div
                  className="progress-bar bg-danger"
                  role="progressbar"
                  style={{ width: "85%" }}
                  aria-valuenow="85"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CollectionView;
